import { createAction, props } from '@ngrx/store';

export enum PoliciesActionTypes {
  DeleteConfirmation = '[Policies Effects] Delete Confirmation',
}

export const PoliciesStateActions = {
  deleteConfirmation: createAction(
    PoliciesActionTypes.DeleteConfirmation,
    props<{ id: number }>()
  ),
};
